import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'scrMoney'
})
export class ScrMoneyPipe implements PipeTransform {

  transform(value: number | null | undefined): string | null {
      const amount = new DecimalPipe(navigator.language).transform(value, '1.2-2');
      return amount ? `$${amount}` : null;
  }
}